import { useState } from "react";
import { Link } from "react-router-dom";
import 'animate.css';
import logo from '../../logo.png';
import useAuthStore from '../../store/auth';


export default function Navbar() {

    // const authenticated = useAuthStore((state) => state.authenticated);

    // const [ openMobileMenu, setOpenMobileMenu ] = useState(false);
    return (
        <>
            <nav className="sticky top-0 z-10 flex justify-center overflow-hidden items-center bg-white xl:px-36 md:px-20 px-6 py-0 h-20 w-full">
                <Link to="/">
                    <div className="relative w-fit">
                        <img src={logo} alt="logo" className="h-8" />

                        <span className="font-semibold text-2xl absolute -top-2 xl:-right-4 -right-5">&reg;</span>

                    </div>
                </Link>

                {/* <div className="invisible md:visible flex justify-center items-center gap-6">
                    <Link to="/the-vision" className=" text-sm font-bold text-gray-800 hover:text-gray-900">The Vision</Link>
                    <Link to="/guidelines" className=" text-sm font-bold text-gray-800 hover:text-gray-900">Guidelines</Link>
                    <Link to="/term-of-use" className=" text-sm font-bold text-gray-800 hover:text-gray-900">Terms</Link>
                </div> */}

                {/* 345 */}

                {/* {authenticated && <Link to="/account/dashboard" className="md:flex items-center gap-2 hidden xl:w-2/6 justify-end">
                    <img src={user.avatar} className="h-8 w-8 rounded-full" alt="" /> 
                    <span className="font-semibold text-sm">{user.name}</span>
                </Link>} */}

                {/* <button className="md:hidden block focus:ring-blue-500 appearance-none focus:outline-none" onClick={() => setOpenMobileMenu(!openMobileMenu)}>
                    {!openMobileMenu  && <span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                            <path fillRule="evenodd" d="M3 6.75A.75.75 0 013.75 6h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 6.75zM3 12a.75.75 0 01.75-.75h16.5a.75.75 0 010 1.5H3.75A.75.75 0 013 12zm8.25 5.25a.75.75 0 01.75-.75h8.25a.75.75 0 010 1.5H12a.75.75 0 01-.75-.75z" clipRule="evenodd" />
                        </svg>
                    </span>}
                    {openMobileMenu  && <span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </span>}
                </button> */}
            </nav>

            {/* {openMobileMenu && <div className={`animate__animated ${openMobileMenu && 'animate__fadeIn'}  ${!openMobileMenu && 'animate__fadeOutUp'} fixed bg-white border-t z-10 shadow md:hidden border-t-blue-200 rounded-b-lg px-6 py-6 w-full`}>
                <ul className="flex flex-col gap-3 justify-start">
                    <li>
                        <Link className="font-semibold text-sm" to="/the-vision">The Vision</Link>
                    </li>
                    <li>
                        <Link className="font-semibold text-sm" to="/guidelines">Guidlines</Link>
                    </li>
                    <li>
                        <Link className="font-semibold text-sm" to="/term-of-use">Terms</Link>
                    </li>
                </ul>

                {!authenticated && <div className="flex justify-center gap-3 mt-4 border-t border-t-gray-300 pt-5 pb-3">
                    <Link to="/auth/sign-in" className="flex justify-center border-2 rounded-md gap-1 transition delay-150 duration-300 ease-in-out hover:border-blue-900  text-blue-800 border-blue-800 items-center w-1/2 py-2">
                        <span className="h-5">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
                            </svg>
                        </span>
                        <span className=" font-bold text-sm">
                            Sign In
                        </span>
                    </Link>
                    <Link to="/auth/sign-up" className="flex justify-center border-2 rounded-md gap-1 transition delay-150 duration-300 ease-in-out hover:bg-blue-900 border-blue-800 bg-blue-800 text-white items-center w-1/2 py-2">
                        <span className="h-5">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
                            </svg>
                        </span>
                        <span className="font-bold text-sm">
                            Sign Up
                        </span>
                    </Link>
                </div>}
                {authenticated && <div className="flex justify-center gap-3 mt-4 border-t border-t-gray-300 pt-5 pb-3">
                    <Link to="/account/dashboard" className="flex justify-center w-full border-2 rounded-md gap-1 transition delay-150 duration-300 ease-in-out hover:border-blue-900  text-blue-800 border-blue-800 items-center py-2">
                        
                        <span className=" font-bold text-sm ">
                            My Account Dashboard
                        </span>
                    </Link>
            
                </div>}
            </div>} */}
        </>
    );
}

